import {DeleteOutlined, PlusOutlined} from '@ant-design/icons';
import {Button, Form, Input, InputNumber, Modal, Select, Space, Upload} from 'antd';
import ImgCrop from 'antd-img-crop';
import PropTypes from 'prop-types';

import {RqAddProduct} from '../../../../reactQuery/apis';

const NewProductScreen = ({
  isModalVisible,
  handleCancel,
  previewUrls,
  form,
  handleFormSubmit,
  handleModalImageUpload,
  handleChange,
  addProductMutation,
}) => {

  // const addProductMutation = RqAddProduct();

  return(
    <div>
      <Modal
        title={'Add New Product'}
        open={isModalVisible}
        onCancel={handleCancel}
        onOk={() => form.submit()}
        okText={'Add Product'}
        confirmLoading={addProductMutation.isLoading}
      >
        <Form form={form} layout={'vertical'} onFinish={handleFormSubmit} initialValues={{size: [{size: '', quantity: 1}]}}>
          <Form.Item label={'Insert Image'} required>
            <ImgCrop rotationSlider>
              <Upload
                accept={'image/*'}
                multiple
                showUploadList={false}
                customRequest={({file}) => handleModalImageUpload({file})}
              >
                <Button type={'primary'}>Upload Image</Button>
              </Upload>
            </ImgCrop>
            {(previewUrls?.length ?? 0) > 0 && (
              <div className={'grid grid-cols-2 md:grid-cols-4 gap-2 mt-2'}>
                {previewUrls.map((url, index) => (
                  <img
                    key={index}
                    src={url}
                    alt={`preview-${index}`}
                    className={'w-full aspect-square object-cover rounded shadow'}
                  />
                ))}
              </div>
            )}
          </Form.Item>

          <Form.Item
            name={'productName'}
            label={'Product Name'}
            rules={[{required: true, message: 'Please enter product name'}]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name={'description'}
            label={'Description'}
            rules={[{required: true, message: 'Please enter description'}]}
          >
            <Input.TextArea rows={3} />
          </Form.Item>

          <div className={'flex justify-between gap-2'}>
            <Form.Item
              className={'w-1/2'}
              name={'jewelryType'}
              label={'Jewelry Type'}
              rules={[{required: true, message: 'Please enter jewelry type'}]}
            >
              <Select
                placeholder={'Select jewelry'}
                className={'text-gray'}
                // defaultValue={'Select jewelry'}
                // style={{width: 120}}
                onChange={handleChange}
                options={[
                  {value: 'GOLD', label: 'Gold'},
                  {value: 'SILVER', label: 'Silver'},
                  {value: 'IMITATION', label: 'Imitation'},
                ]}
              />
            </Form.Item>

            <Form.Item
              className={'w-1/2'}
              name={'productType'}
              label={'Product Type'}
              rules={[{required: true, message: 'Please enter product type'}]}
            >
              <Input />
            </Form.Item>
          </div>

          <div className={'flex justify-between gap-2'}>
            <Form.Item
              className={'w-1/2'}
              name={'grossWeight'}
              label={'Gross Weight'}
              rules={[{required: true, message: 'Please enter gross weight'}]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              className={'w-1/2'}
              name={'netWeight'}
              label={'Net Weight'}
              rules={[{required: true, message: 'Please enter net weight'}]}
            >
              <Input />
            </Form.Item>
          </div>

          <Form.List name={'size'}>
            {(fields, {add, remove}) => (
              <>
                <p className={'block font-medium mb-1'}>
        Size, Quantity & Price
                </p>

                {fields.map(({key, name, ...restField}) => (
                  <Space key={key} align={'baseline'}>

                    <Form.Item
                      {...restField}
                      name={[name, 'size']}
                      rules={[{required: true}]}
                    >
                      <Input placeholder={'Size'} />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, 'quantity']}
                      rules={[{required: true}]}
                    >
                      <InputNumber min={1} placeholder={'Qty'} />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, 'price']}
                      rules={[{required: true}]}
                    >
                      <InputNumber min={0} placeholder={'Price'} />
                    </Form.Item>

                    <Button danger onClick={() => remove(name)}>
                      <DeleteOutlined />
                    </Button>

                  </Space>
                ))}

                <Button type={'dashed'} onClick={() => add()}>
        Add Size
                </Button>
              </>
            )}
          </Form.List>
        </Form>

      </Modal>
    </div>
  );
};

NewProductScreen.propTypes = {
  isModalVisible: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func.isRequired,
  previewUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
  form: PropTypes.object.isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  handleModalImageUpload: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,

  addProductMutation: PropTypes.shape({
    mutate: PropTypes.func,
    isLoading: PropTypes.bool,
  }),

  editModal: PropTypes.shape({
    visible: PropTypes.bool,
    record: PropTypes.object,
  }),

  formTwo: PropTypes.object,
  setEditModal: PropTypes.func,
  token: PropTypes.string,
  setPreviewUrls: PropTypes.func,
  imageFiles: PropTypes.array,
  setImageFiles: PropTypes.func,
  dataSource: PropTypes.array,
  setDataSource: PropTypes.func,
  updateProductMutation: PropTypes.shape({
    mutate: PropTypes.func,
    isLoading: PropTypes.bool,
  }),
};

export default NewProductScreen;
